import {decodeQueryParam} from "./transformer";
import { IParsedJWT, LoginState} from "./IAuthentication";
import {jwtDecode} from "jwt-decode";
import {loginURL, LogoutURL} from "../Config/authorization";
import {fetchFromApi, getBackendApiURL} from "../BackendFacade";

const idToken = "id_token2";
const refreshToken = "refresh_token2";

export let isProcessingLoginCode = false;

/**
 * Check if the user is logged in. If not, redirect to login page. Evaluate the code from the url if given.
 * @returns
 */
export async function evaluateLoginCode(): Promise<LoginState> {
    // is the token in the url?
    const search = window.location.href.split("?");

    // remove the code from the url, everything from ? to the #, keep everything after the #, including the #
    window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);

    if (search.length <= 1 || !(search[1].indexOf('=') !== -1)) {
        // return false if no token is set, so the website stops loading while redirecting
        return {success: hasToken(), error: ""};
    }

    const params = search[1].split('&');
    const dict = {};
    params.forEach((item) => {
        const parts = item.split('=');
        dict[parts[0]] = parts[1];
    })
    // error code in url received,
    if (dict["error"]) {
        // forwarded the error to the user
        if (dict["error_description"]) {
            return {
                success: false,
                error: decodeQueryParam(decodeURIComponent(dict["error_description"] as string))
            }
        } else {
            return {success: false, error: decodeQueryParam(decodeURIComponent(dict["error"] as string))}
        }
    }

    // received a code in url, send it to backend to get tokens
    if (dict["code"]) {
        isProcessingLoginCode = true;
        const resp = await fetchFromApi(getBackendApiURL() + "static/b2cLogin", "POST",
            "code=" + dict["code"] + "&state=" + dict["state"],
            "application/x-www-form-urlencoded");

        window.location.reload();

        return {success: resp.success, error: resp.message}
    }

    return {success: hasToken(), error: ""};

}

export function removeTokens() {
    localStorage.removeItem(idToken);
    localStorage.removeItem(refreshToken);
}

export function openLoginPage() {
    removeTokens()
    window.location.href = loginURL
}

export function openLogoutPage() {
    const token = getToken()
    removeTokens()
    window.location.href = LogoutURL + token
}

/**
 * Sets the id_token and refresh_token from the response header.
 * @param dict Response from B2C
 */
export function setTokensFromHeader(dict: Response) {
    if (dict.headers.get("id_token") !== null) {
        setToken(dict.headers.get("id_token") as string)
    }
    if (dict.headers.get("refresh_token") !== null) {
        setRefreshToken(dict.headers.get("refresh_token") as string)
    }
}

export function getUserRole() {
    const decoded = jwtDecode<IParsedJWT>(getToken());
    return decoded.authLevel
}

export function getUserEmail() {
    const decoded = jwtDecode<IParsedJWT>(getToken());
    return decoded.email_address
}

export function getToken() {
    const jwt = localStorage.getItem(idToken);
    if (!jwt) throw new Error("no session found!");
    return jwt;
}

export function hasToken() {
    const jwt = localStorage.getItem(idToken);
    return jwt !== null;
}

export function setToken(token: string) {
    localStorage.setItem(idToken, token)
}

export function setRefreshToken(token: string) {
    localStorage.setItem(refreshToken, token)
}

export function getRefreshToken() {
    return localStorage.getItem(refreshToken)
}
